import {clsx} from 'clsx'

import styles from './StyledInputBlocks.module.css'

/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
export const TextBlock = ({text}: {text: string}) => <span className="text-block">{text}</span>

/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
export const SpaceBlock = ({text}: {text: string}) => <span className="delimiter space-delimiter">{text}</span>

/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
export const Delimiter = ({delimiter}: {delimiter: string}) => <span className="delimiter">{delimiter}</span>

export const KeywordBlock = ({keyword}: {keyword: string}) => (
  /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
  <span className={clsx('keyword-block', styles.Text_0)}>{keyword}</span>
)

export const KeyBlock = ({text, className}: {text: string; className?: string}) => (
  <span data-type="filter" className={className}>
    {text}
  </span>
)
